<template>
  <div>
    <div v-if="!finished">

      <h2>{{question}}</h2>

      <div
        v-for="q in options"
        :key="q.option"
      >
        <b-button
          block
          variant="primary"
          @click="updateQuestion(q)"
        >{{q.option}}</b-button>
        <br>
      </div>
    </div>
    <div v-else>
      <h1>{{result.result}}</h1>

      <img
        v-if="result.love"
        src="/static/love.jpg"
      >

      <img
        v-else
        src="/static/vuil.jpg"
      >

      <b-button
        block
        variant="primary"
        @click="reset"
      >Opnieuw?</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
      questions: {
        "question": "Is de kaas Nederlands?",
        "options": [
          {
            "option": "Ja",
            "finished": false,
            "next_question": {
              "question": "Komt de kaas uit de koelkast?",
              "options": [
                {
                  "option": "Ja",
                  "finished": false,
                  "next_question": {
                    "question": "Is de kaas jong of oud?",
                    "options": [
                      {
                        "option": "(Jong) belegen",
                        "finished": false,
                        "next_question": {
                          "question": "Is de kaas 48+?",
                          "options": [
                            {
                              "option": "Ja",
                              "finished": true,
                              "love": true,
                              "result": "Ik lust het"
                            },
                            {
                              "option": "Nee",
                              "finished": true,
                              "love": false,
                              "result": "Waarschijnlijk vind ik het smerig"
                            }
                          ]
                        }
                      },
                      {
                        "option": "Oud",
                        "finished": true,
                        "love": false,
                        "result": "Waarschijnlijk vind ik het smerig"
                      }
                    ]
                  }
                },
                {
                  "option": "Nee",
                  "finished": false,
                  "next_question": {
                    "question": "Zit het op *niet door* pizza, tosti of pasta?",
                    "options": [
                      {
                        "option": "Ja",
                        "finished": true,
                        "love": true,
                        "result": "Ja, ik lust het"
                      },
                      {
                        "option": "Nee",
                        "finished": true,
                        "love": false,
                        "result": "Nee, goor"
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            "option": "Nee",
            "finished": false,
            "next_question": {
              "question": "Waarschijnlijk lust ik het niet maar oke. Is het mozarella of parmezaans?",
              "options": [
                {
                  "option": "Ja",
                  "finished": true,
                  "love": true,
                  "result": "Ja ik lust het"
                },
                {
                  "option": "Nee",
                  "finished": true,
                  "love": false,
                  "result": "Stop maar, tis vuil!"
                }
              ]
            }
          }
        ]
      },
      question: "",
      finished: false,
      options: [],
      result: {},
    }
  },

  methods: {
    updateQuestion (option) {
      if (option.finished) {
        this.finished = true;
        this.result = option;
      } else {
        this.question = option.next_question.question;
        this.options = option.next_question.options;
      }
    },

    reset () {
      this.finished = false;
      this.question = this.questions.question;
      this.options = this.questions.options;
    }
  },

  mounted () {
    this.reset();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue